export default "__VITE_ASSET__afbe72b2__"